/** When your routing table is too long, you can split it into small modules**/

import Layout from "@/views/layout/layout";

const merchantOrderCheckRouter = {
  path: "/merchantOrderCheck",
  component: Layout,
  hidden: false,
  alwaysShow: true,
  redirect: "noredirect",
  name: "merchantOrderCheck",
  meta: {
    title: "订单查询",
    icon: "order",
    roles: ["merchant"],
  },
  children: [
    {
      path: "merchantTransactionOrder-116",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/merchantTransactionOrder",
        ], resolve),
      name: "MerchantTransactionOrder",
      meta: { title: "商户网银充值", noCache: false },
    },
    {
      path: "merchantTransactionOrderU-116",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/merchantTransactionOrderU",
        ], resolve),
      name: "MerchantTransactionOrderU",
      meta: { title: "商户USDT充值", noCache: false },
    },
    {
      path: "merchantUSDTOrder",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/merchantUSDTOrder",
        ], resolve),
      name: "MerchantUSDTOrder",
      meta: { title: "USDT订单", noCache: false },
    },
    // {
    //   path: 'merchantCFBOrder',
    //   component: resolve => require(['@/views/merchant/merchantOrderCheck/merchantCFBOrder'], resolve),
    //   name: 'MerchantCFBOrder',
    //   meta: { title: 'CFB订单', noCache: false }
    // },
    {
      path: "merchantWithdrawOrder",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/merchantWithdrawOrder",
        ], resolve),
      name: "MerchantWithdrawOrder",
      meta: { title: "商户提现订单", noCache: false },
    },
    {
      path: "merchantPaidOrder-117",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/merchantPaidOrder",
        ], resolve),
      name: "MerchantPaidOrder",
      meta: { title: "代付订单", noCache: false },
    },
    // {
    //   path: 'interceptPaidOrder-118',
    //   component: resolve => require(['@/views/merchant/merchantOrderCheck/interceptPaidOrder'], resolve),
    //   name: 'InterceptPaidOrder',
    //   meta: { title: '代付拦截', noCache: false }
    // },
    {
      path: "PaidOrderAudit",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/PaidOrderAudit",
        ], resolve),
      name: "PaidOrderAudit",
      meta: { title: "待审核提现订单", noCache: false },
    },
    {
      path: "approvedPaidOrder",
      component: (resolve) =>
        require([
          "@/views/merchant/merchantOrderCheck/approvedPaidOrder",
        ], resolve),
      name: "ApprovedPaidOrder",
      meta: { title: "已审核提现订单", noCache: false },
    },
    {
      path: "quickLink",
      component: (resolve) =>
        require(["@/views/merchant/merchantOrderCheck/quickLink"], resolve),
      name: "QuickLink",
      meta: { title: "快捷支付链接", noCache: false },
    },
    {
      path: "zxQuickLink",
      component: (resolve) =>
        require(["@/views/merchant/merchantOrderCheck/zxQuickLink"], resolve),
      name: "ZxQuickLink",
      meta: { title: "泽熙支付地址", noCache: false },
    },
  ],
};

export default merchantOrderCheckRouter;



// WEBPACK FOOTER //
// ./src/router/merchant/merchantOrderCheck.js